import { CardsSectionProps } from '../config';
import { DETAIL_PHYSICAL_CARD_INFO_MAP } from '../consts';
import { formatAmount } from '../utils';
import Accordion from './Accordion';
import InfoGrid from './InfoGrid';
import InfoRow from './InfoRow';

function PhysicalCards({ order }: CardsSectionProps) {
  const cards = order.cards;

  if (cards.length === 0) {
    return <div className="text-base">No cards on this order</div>;
  }

  const premoReferences = cards.map((card) => card.premo_reference).filter(Boolean);

  return (
    <div className="flex flex-col divide-y divide-palette-color-bg-grey">
      <div className="pb-4">
        <InfoRow
          label={premoReferences.length === 1 ? 'Premo reference' : 'Premo references'}
          value={premoReferences.length > 0 ? premoReferences.join(', ') : '—'}
          copyable
          stacked
          breakAll
        />
      </div>
      {cards.map((card, index) => (
        <Accordion
          key={card.uuid}
          label={
            <>
              <span className="text-palette-secondary-grey font-normal">{`Card ${index + 1} · `}</span>
              {card.recipient_name || '—'}
            </>
          }
          meta={`${card.quantity} × ${formatAmount(card.gift_card_amount, card.currency)}`}
        >
          <div className="pb-4">
            <InfoGrid rows={DETAIL_PHYSICAL_CARD_INFO_MAP} entity={card} breakAll />
          </div>
        </Accordion>
      ))}
    </div>
  );
}

export default PhysicalCards;
